import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

import { DrawerState } from '../types/drawer'

export async function persistDrawerState(value: DrawerState): Promise<void> {
  if (value.direction === 'initial') {
    return
  }

  const url = window.Silverfin.Routes.toggle_sidepane_open_users_path(
    window.Silverfin.currentFirmId,
    { content: value.content, position: value.direction }
  )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot persist drawer state', {
      error: e,
    })
  }
}

export async function persistSidepaneOpenCompletedTodosState(
  value: boolean
): Promise<void> {
  const url =
    window.Silverfin.Routes.update_sidepane_open_completed_todos_users_path(
      window.Silverfin.currentFirmId,
      { value }
    )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot persist sidepane open completed todos state', {
      error: e,
    })
  }
}
